import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function DetallesTrabajo({ trabajo, onCerrar, onActualizar }) {
  const [fotos, setFotos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [fotoAmpliada, setFotoAmpliada] = useState(null);
  const [vista, setVista] = useState('detalle'); // 'detalle' | 'observaciones' | 'editar'
  const [observaciones, setObservaciones] = useState([]);
  const [nuevaObs, setNuevaObs] = useState({ autor: '', texto: '' });
  const [formEditar, setFormEditar] = useState({
    titulo: trabajo.titulo,
    tipo: trabajo.tipo,
    descripcion: trabajo.descripcion || '',
    estado: trabajo.estado,
    autor: trabajo.autor || '',
    fecha: trabajo.fecha || '',
    fecha_inicio: trabajo.fecha_inicio || '',
    fecha_fin: trabajo.fecha_fin || '',
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => { cargarFotos(); cargarObservaciones(); }, [trabajo.id]);

  async function cargarFotos() {
    const { data } = await supabase.from('fotos').select('*').eq('trabajo_id', trabajo.id);
    setFotos(data || []);
  }

  async function cargarObservaciones() {
    const { data } = await supabase
      .from('observaciones')
      .select('*')
      .eq('trabajo_id', trabajo.id)
      .order('created_at', { ascending: true });
    setObservaciones(data || []);
  }

  async function subirFoto(e) {
    const archivo = e.target.files[0];
    if (!archivo) return;
    setSubiendo(true);
    const nombre = `${trabajo.id}_${Date.now()}_${archivo.name}`;
    const { error: uploadError } = await supabase.storage.from('fotos').upload(nombre, archivo);
    if (uploadError) { alert('Error al subir foto'); setSubiendo(false); return; }
    const { data: urlData } = supabase.storage.from('fotos').getPublicUrl(nombre);
    await supabase.from('fotos').insert([{ trabajo_id: trabajo.id, url: urlData.publicUrl }]);
    cargarFotos();
    setSubiendo(false);
  }

  async function agregarObservacion() {
    if (!nuevaObs.autor || !nuevaObs.texto) return alert('Completá autor y observación');
    await supabase.from('observaciones').insert([{
      trabajo_id: trabajo.id,
      autor: nuevaObs.autor,
      texto: nuevaObs.texto
    }]);
    setNuevaObs({ autor: '', texto: '' });
    cargarObservaciones();
  }

  async function guardarEdicion() {
    const { error } = await supabase.from('trabajos').update({
      titulo: formEditar.titulo,
      tipo: formEditar.tipo,
      descripcion: formEditar.descripcion,
      estado: formEditar.estado,
      autor: formEditar.autor,
      fecha: formEditar.fecha || null,
      fecha_inicio: formEditar.fecha_inicio || null,
      fecha_fin: formEditar.fecha_fin || null,
    }).eq('id', trabajo.id);
    if (!error) { onActualizar(); onCerrar(); }
    else alert('Error al guardar: ' + error.message);
  }

  async function eliminar() {
    if (window.confirm('¿Seguro que querés eliminar este trabajo?')) {
      await supabase.from('trabajos').delete().eq('id', trabajo.id);
      onActualizar();
      onCerrar();
    }
  }

  const abrirInforme = () => {
    const params = new URLSearchParams({
      id: trabajo.id,
      titulo: trabajo.titulo,
      tipo: trabajo.tipo,
      seccion: trabajo.secciones?.nombre || '',
      autor: trabajo.autor || '',
      descripcion: trabajo.descripcion || '',
      fecha: trabajo.fecha || '',
      fecha_inicio: trabajo.fecha_inicio || '',
      fecha_fin: trabajo.fecha_fin || '',
      estado: trabajo.estado || '',
      latitud: trabajo.latitud,
      longitud: trabajo.longitud,
      codigo_informe: trabajo.codigo_informe || '',
      numero_trabajo: trabajo.numero_trabajo || '',
      lugar: trabajo.lugar || '',
      hora_inicio: trabajo.hora_inicio || '',
      hora_fin: trabajo.hora_fin || '',
      kilometros: trabajo.kilometros || '',
      desarrollo: trabajo.desarrollo || '',
    });
    window.open(`/informe.html?${params.toString()}`, '_blank');
  };

  const estadoColor = {
    pendiente: '#f59e0b',
    'en progreso': '#3b82f6',
    finalizado: '#22c55e'
  };

  const formatFecha = (f) => f ? new Date(f + 'T00:00:00').toLocaleDateString('es-AR') : '—';

  return (
    <div className="modal-overlay">
      <div className="modal">

        {/* Header */}
        <div className="detalle-header">
          <h2>{trabajo.titulo}</h2>
          <span className="badge" style={{ background: estadoColor[trabajo.estado] || '#888' }}>
            {trabajo.estado}
          </span>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button className={vista === 'detalle' ? 'tab active' : 'tab'} onClick={() => setVista('detalle')}>📋 Detalle</button>
          <button className={vista === 'observaciones' ? 'tab active' : 'tab'} onClick={() => setVista('observaciones')}>
            💬 Observaciones {observaciones.length > 0 && <span className="obs-count">{observaciones.length}</span>}
          </button>
          <button className={vista === 'editar' ? 'tab active' : 'tab'} onClick={() => setVista('editar')}>✏️ Editar</button>
        </div>

        {/* Vista Detalle */}
        {vista === 'detalle' && (
          <>
            <div className="detalle-info">
              <p><strong>Tipo:</strong> {trabajo.tipo}</p>
              <p><strong>Provincia:</strong> {trabajo.secciones?.nombre}</p>
              <p><strong>Encargado:</strong> {trabajo.autor || '—'}</p>
              <p><strong>Fecha:</strong> {formatFecha(trabajo.fecha)}</p>
              <p><strong>Inicio:</strong> {formatFecha(trabajo.fecha_inicio)}</p>
              <p><strong>Fin:</strong> {formatFecha(trabajo.fecha_fin)}</p>
              <p><strong>Descripción:</strong> {trabajo.descripcion || '—'}</p>
              <p><strong>Coordenadas:</strong> {trabajo.latitud}, {trabajo.longitud}</p>
            </div>
            <div className="fotos-seccion">
              <h3>Fotos</h3>
              <div className="fotos-grid">
                {fotos.map(f => (
                  <img key={f.id} src={f.url} alt="foto" className="foto-thumb" onClick={() => setFotoAmpliada(f.url)} />
                ))}
              </div>
              <label className="btn-foto">
                {subiendo ? 'Subiendo...' : '📷 Agregar foto'}
                <input type="file" accept="image/*" onChange={subirFoto} hidden />
              </label>
            </div>
          </>
        )}

        {/* Vista Observaciones */}
        {vista === 'observaciones' && (
          <div className="obs-container">
            <div className="obs-lista">
              {observaciones.length === 0 && <p className="obs-vacio">Sin observaciones todavía.</p>}
              {observaciones.map(o => (
                <div key={o.id} className="obs-item">
                  <div className="obs-header">
                    <strong>{o.autor}</strong>
                    <span>{new Date(o.created_at).toLocaleDateString('es-AR', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })}</span>
                  </div>
                  <p>{o.texto}</p>
                </div>
              ))}
            </div>
            <div className="obs-nueva">
              <input
                placeholder="Tu nombre"
                value={nuevaObs.autor}
                onChange={e => setNuevaObs({...nuevaObs, autor: e.target.value})}
              />
              <textarea
                placeholder="Escribí una observación..."
                value={nuevaObs.texto}
                onChange={e => setNuevaObs({...nuevaObs, texto: e.target.value})}
              />
              <button onClick={agregarObservacion} className="btn-obs-enviar">Agregar observación</button>
            </div>
          </div>
        )}

        {/* Vista Editar */}
        {vista === 'editar' && (
          <div className="editar-form">
            <input value={formEditar.titulo} onChange={e => setFormEditar({...formEditar, titulo: e.target.value})} placeholder="Título" />
            <select value={formEditar.tipo} onChange={e => setFormEditar({...formEditar, tipo: e.target.value})}>
              <option value="mantenimiento">Mantenimiento</option>
              <option value="reparacion">Reparación</option>
              <option value="inspeccion">Inspección</option>
              <option value="instalacion">Instalación</option>
            </select>
            <select value={formEditar.estado} onChange={e => setFormEditar({...formEditar, estado: e.target.value})}>
              <option value="pendiente">Pendiente</option>
              <option value="en progreso">En progreso</option>
              <option value="finalizado">Finalizado</option>
            </select>
            <input value={formEditar.autor} onChange={e => setFormEditar({...formEditar, autor: e.target.value})} placeholder="Encargado" />
            <textarea value={formEditar.descripcion} onChange={e => setFormEditar({...formEditar, descripcion: e.target.value})} placeholder="Descripción" />
            <label>Fecha del trabajo</label>
            <input type="date" value={formEditar.fecha} onChange={e => setFormEditar({...formEditar, fecha: e.target.value})} />
            <label>Fecha inicio</label>
            <input type="date" value={formEditar.fecha_inicio} onChange={e => setFormEditar({...formEditar, fecha_inicio: e.target.value})} />
            <label>Fecha fin</label>
            <input type="date" value={formEditar.fecha_fin} onChange={e => setFormEditar({...formEditar, fecha_fin: e.target.value})} />
            <button onClick={guardarEdicion} className="btn-guardar-edicion">💾 Guardar cambios</button>
          </div>
        )}

        {/* Botones — Opción 2 */}
        <div className="botones-dos-filas">
          <div className="fila-principal">
            <button className="btn-accion btn-azul" onClick={() => setVista('editar')}>✏️ Editar</button>
            <button className="btn-accion btn-oscuro" onClick={abrirInforme}>📄 Ver informe</button>
          </div>
          <div className="fila-secundaria">
            <button className="btn-accion btn-violeta" onClick={() => setVista('observaciones')}>💬 Observaciones</button>
            <button className="btn-accion btn-rojo" onClick={eliminar}>🗑️ Eliminar</button>
            <button className="btn-accion btn-gris" onClick={onCerrar}>✕ Cerrar</button>
          </div>
        </div>
      </div>

      {fotoAmpliada && (
        <div className="foto-overlay" onClick={() => setFotoAmpliada(null)}>
          <img src={fotoAmpliada} alt="ampliada" className="foto-ampliada" />
        </div>
      )}
    </div>
  );
}

export default DetallesTrabajo;